import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from "@angular/core";
import {UtilsService} from "../../../../core/utils/utils.service";
import {TypePeriodeFacturationEnum} from "../../../../core/enums/facturation/client/type-periode-facturation-enum";
import {LigneParametrageFacturation} from "../../../../core/models/facturation/client/ligne-parametrage-facturation";
import {ToolbarPreparingEvent} from "devextreme/ui/data_grid";
import {DxDataGridComponent} from "devextreme-angular";

@Component({
  selector: 'yo-ligne-parametrage-famille-facturation-data-grid',
  templateUrl: './ligne-parametrage-famille-facturation-data-grid.component.html',
  styleUrls: ['./ligne-parametrage-famille-facturation-data-grid.component.scss'],
  standalone: false
})
export class LigneParametrageFamilleFacturationDataGridComponent implements OnInit, OnDestroy {

  @ViewChild("grid") grid: DxDataGridComponent;

  @Input() lignes: LigneParametrageFacturation[];
  @Output() onFilter: EventEmitter<TypePeriodeFacturationEnum[]> = new EventEmitter();

  periodes = [
    {value: TypePeriodeFacturationEnum.PASSE, text: 'Prix de vente passés'},
    {value: TypePeriodeFacturationEnum.EN_COURS, text: 'Prix de vente en cours'},
    {value: TypePeriodeFacturationEnum.FUTUR, text: 'Prix de vente futurs'},
  ];

  selectedPeriode: TypePeriodeFacturationEnum[] = [];

  constructor(public utilsSvc: UtilsService) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
  }

  onToolbarPreparing($event: ToolbarPreparingEvent) {
    $event.toolbarOptions.items.unshift(
      {
        location: "before",
        template: "beforeTemplate"
      },
      {
        location: "after",
        template: "afterTemplate"
      }
    );
  }

  onGridOptionChanged(e: any) {
    if (e.fullName?.includes('columns[8].filterValue')) {
      this.selectedPeriode = e.value;
      this.onFilter.emit(this.selectedPeriode);
    }
  }

  getSelectedData(): any[] {
    return this.grid.selectedRowKeys;
  }

  calculateFilterExpression(filterValue, selectedFilterOperation, target) {
    return null;
  }

}
